import { SDK } from '../index';
import {
    Avatar,
    AvatarsQueryVariables,
    QueryFindManyAvatarArgs,
    ResultSuccess,
} from '../generated/graphql';
import { FetchPolicy } from '@apollo/client/core/watchQueryOptions';

export const findManyAvatar = async (
    sdk: SDK,
    args?: QueryFindManyAvatarArgs,
    fetchPolicy: FetchPolicy = 'cache-first',
): Promise<Array<Avatar> | ResultSuccess> => {
    const query = require('../graphql/queries/avatars.query.gql');
    const params: AvatarsQueryVariables = sdk.buildParams<
        unknown,
        QueryFindManyAvatarArgs,
        AvatarsQueryVariables
    >(null, 'Avatar', args);
    return sdk.query<
        {
            findManyAvatar: Array<Avatar>;
        },
        AvatarsQueryVariables
    >(
        {
            query: query,
            variables: params,
            fetchPolicy,
        },
        'findManyAvatar',
        false,
    );
};
